import type { RecommendationItem } from '@kimuno/api-sdk';

import { LOGOUT, type LogoutAction } from '../actions/auth.actionTypes';
import { AsyncActionStatus } from '../actions/common.actionTypes';
import {
	FETCH_DASHBOARD_RECOMMENDATIONS,
	type FetchDashboardRecommendationsAction,
} from '../actions/recommendations.actionTypes';

type RecommendationsActionTypes = FetchDashboardRecommendationsAction | LogoutAction;

export interface RecommendationsState {
	status: AsyncActionStatus;
	items: RecommendationItem[];
}

const initialState: RecommendationsState = {
	status: AsyncActionStatus.INITIAL,
	items: [],
};

const recommendations = (
	// biome-ignore lint/style/useDefaultParameterLast: parameter order is a fixed contract (Redux reducer signature / existing call sites)
	state = initialState,
	action: RecommendationsActionTypes
): RecommendationsState => {
	switch (action.type) {
		case LOGOUT.SUCCESS:
			return initialState;

		case FETCH_DASHBOARD_RECOMMENDATIONS.START:
			return { ...state, status: AsyncActionStatus.LOADING };

		case FETCH_DASHBOARD_RECOMMENDATIONS.SUCCESS:
			return {
				status: AsyncActionStatus.READY,
				items: [...action.result.recommendations.items].sort((a, b) => a.position - b.position),
			};

		case FETCH_DASHBOARD_RECOMMENDATIONS.ERROR:
			return { ...state, status: AsyncActionStatus.ERROR };
	}

	return state;
};

export default recommendations;
